import React, {useEffect, useState} from 'react';
import {BRCustomizedTooltip as Tooltip} from "../../../../../components/customBreachBits/accents/BRCustomizedTooltip";
import Banner from "../../../../../assets/images/BreachRisk-Report-Banner.svg";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {useDispatch, useSelector} from "react-redux";
import VectorRiskScoreLineChart, {
    // testHistoryData
} from "../../../../../components/customBreachBits/charts/VectorRiskScoreLineChart";
import VectorRisk2DScatterPlot from "../../../../../components/customBreachBits/charts/VectorRisk2DScatterPlot";
import {
    bbDangerousStringToDate,
    bbDoesCustomerHaveAccessToSubscriptionLevel,
    bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString, bbIsEntityAwaitingFirstScoreCycle,
    bbTranslateBreachRiskScoreToCategory,
    bbTranslateBreachRiskScoreToColor, isCurrentUserMemberOf
} from "../../../../../util/bbHelpers";
import BRReportFindingsSummary
    from "../../../../../components/customBreachBits/BreachRiskReport/BRReportFindingsSummary";
import BRThreatsSummaryTable from "../../../../../components/customBreachBits/BreachRiskReport/BRThreatsSummaryTable";
import {Badge, Col, Row} from "reactstrap";
import Skeleton from "react-loading-skeleton";
import BreachRiskScoreCyclePendingModal
    from "../../../../../components/customBreachBits/modals/BreachRiskScoreCyclePendingModal";
import BRFidelityBadge from "../../../../../components/customBreachBits/BRPortfolio/BRFidelityBadge";
// import ReportHistoryDialog from "./ReportHistoryDialog";
import CycleProgressStepper from "../../../../../components/customBreachBits/info/CycleProgressStepper";
import {fetchRiskCycleReport} from "../../../../../actions";
import {Paper} from "@material-ui/core";
import BreachRiskMeter from "../../../../../components/customBreachBits/BreachRiskMeter/BreachRiskMeter";
import Select from "react-select";
import {CircularProgress} from "@mui/material";
import BRCompanyScopeProgressBadge
    from "../../../../../components/customBreachBits/BBRiskMeter/BRCompanyScopeProgressBadge";
import BRCompanyScoreVerifiedBadge
    from "../../../../../components/customBreachBits/BBRiskMeter/BRCompanyScoreVerifiedBadge";

const Dashboard= ({
    portfolioView = false
                  }) => {

    const {customers, customerInView, } = useSelector(({customer}) => customer);
    const {authUser} = useSelector(({auth}) => auth);

    const {entityInView, portfolios, loadingCycles, loadingCyclesError} = useSelector(({breachrisk}) => breachrisk);

    const dispatch = useDispatch();
    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;

    const isAdminStaff = isCurrentUserMemberOf(authUser,"admin") || isCurrentUserMemberOf(authUser, "staff");

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);
    const lastCycle = myEntity && myEntity.last_cycle ? myEntity.last_cycle : null


    const breachRiskScore = myEntity && myEntity.last_cycle ? parseFloat(myEntity.last_cycle.score).toFixed(1) : null;
    const breachRiskCategory = bbTranslateBreachRiskScoreToCategory(breachRiskScore);

    const isCycleOngoing = myEntity
        && myEntity.settings
        && myEntity.settings.ongoing_cycle_complete_datetime;

    const hasPremiumSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 11);

    // const [cycleInView, setCycleInView] = useState(myEntity && myEntity.settings && myEntity.settings.last_cycle_id);
    const historyData = (myEntity
    && myEntity.history
    && Array.isArray(myEntity.history))
        ? myEntity.history
        :null;

    const sortedHistory = historyData && historyData
        .sort((a,b) => (bbDangerousStringToDate(a.cycle_date) > bbDangerousStringToDate(b.cycle_date) ? 1 : -1))

    // const sortedHistory = testHistoryData
    //     .sort((a,b) => (bbDangerousStringToDate(a.cycle_date) > bbDangerousStringToDate(b.cycle_date) ? 1 : -1))
    //
    const [cycleInView, setCycleInView] = useState( myEntity
        && myEntity.last_cycle
        && myEntity.last_cycle.cycle);
    const [isPastReport, setIsPastReport] = useState(cycleInView !== (myEntity && myEntity.last_cycle && myEntity.last_cycle.cycle))
    // const [cycleInView, setCycleInView] = useState(myEntity && myEntity.settings && myEntity.settings.last_cycle_id);

    const cycleDetailsToView = myEntity && cycleInView && myEntity.cycles && myEntity.cycles[cycleInView];


    const pastBreachRiskScore = (myEntity
        && cycleInView
        && myEntity.cycles
        && myEntity.cycles[cycleInView]
        && myEntity.cycles[cycleInView].summary)
        ? parseFloat(myEntity.cycles[cycleInView].summary.score).toFixed(1)
        : null;
    const pastBreachRiskCategory = (myEntity && cycleInView && breachRiskScore) && bbTranslateBreachRiskScoreToCategory(breachRiskScore);

    const chartCallBackToChangeCycleToView = (cycleId) => {
        console.log("Got chartCallBackToChangeCycleToView", cycleId);
        // alert(cycleId);
        setCycleInView(cycleId);
        setIsPastReport(cycleId !== myEntity.last_cycle.cycle)
    }

    const handleOnClick = (cycleId) =>{
        setCycleInView(cycleId);
        setIsPastReport(cycleId !== myEntity.last_cycle.cycle)

    }

    useEffect(()=>{
        if(cycleInView
            && myEntity
            && myEntity.cycles
            && !myEntity.cycles[cycleInView] && !loadingCycles[cycleInView]){
            dispatch(fetchRiskCycleReport({
                customerId: customerIdToUse,
                cycleId: cycleInView
            }))

        }

    }, [cycleInView])

    useEffect(()=>{
        // if(cycleInView !== lastCycle
            // || !sortedHistory.map(history=> history.cycle).includes(cycleInView)){
            setCycleInView( myEntity
                && myEntity.last_cycle
                && myEntity.last_cycle.cycle);
        // }
    },[entityInView])

// console.log("looking at default cycle id and how it works", cycleInView, "what is myEntity and dirll down", myEntity, )
    return (
        // <MultiBoardWrapper customer={customer}>
        <div className="app-wrapper">
      <div className="animated fadeIn animation-duration-7">

          <div className="row">
              <div className={"col-8 align-self-center"}>
                  <div className={"mx-0 px-0"}>
                      <div style={{backgroundImage: `url(${Banner})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>
                      {/*<h2>Overview</h2>*/}
                      <h3>{!bbIsEntityAwaitingFirstScoreCycle(myEntity) && <> {myEntity && myEntity.settings ? bbFormattedDateString(myEntity.settings.last_cycle_datetime, "shortFullMonth") : ""} | </>}{myEntity ? myEntity.name : ""}
                          <span>
                              <BRCompanyScoreVerifiedBadge
                                  entityId={entityInView}
                                  hideDescription
                                  fontSizeOverride={"1.0em"}
                                  inline
                              />
                          </span>
                      </h3>
                      <h2>
                          {/*<Tooltip title={`This BreachRisk™ Score is ${breachRiskScore} out of 10. Higher numbers indicate a higher relative risk that a cyber breach will occur in the foreseeable future.`}>*/}
                          <span>BreachRisk™ Score: <strong>{breachRiskScore}</strong><small> /10</small></span>
                          {/*</Tooltip> */}
                          &nbsp;{myEntity ?
                          <Tooltip heading={"Risk Categories"}
                                   width={"400px"}
                                   examples={[
                                       {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-lowest"}>Very Low Risk</Badge></p>,
                                           text: null,},
                                       {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-low"}>Low Risk</Badge></p>,
                                           text: null,},
                                       {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-medium"}>Medium Risk</Badge></p>,
                                           text: null,},
                                       {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-high"}>High Risk</Badge></p>,
                                           text: null,},
                                       {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-highest"}>Very High Risk</Badge></p>,
                                           text: null,},
                                   ]}>
                              <span><Badge color={bbTranslateBreachRiskScoreToColor(breachRiskScore)}>{breachRiskCategory} Risk</Badge></span>
                           </Tooltip>
                          : <Skeleton />
                      } &nbsp; &nbsp; {myEntity ?
                          <span> <BRFidelityBadge cycleObject={lastCycle}/></span> : <> </>
                      }

                          <span>
                              <BRCompanyScopeProgressBadge
                                  entityId={entityInView}
                                  hideDescription
                                  fontSizeOverride={"1.5em"}
                                  inline
                              />
                          </span>

                      </h2>
                  </div>
                  <p>Get your entire company involved in the conversation; not just the security team. BreachRisk™ Report is designed to be actionable and help sustain a conversation around cyber risk: from the boardroom to the server room.</p>
              </div>
              <div className={"col-4 align-self-center"}>
                  <h3>Details worth talking about. <Tooltip heading={"BreachRisk™ Report"} link={"https://support.breachbits.com/knowledge/whats-the-breachrisk-report"}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                  <p>BreachRisk™ Report explains the <em>why</em> behind BreachRisk™ Score. </p>
                  {isCycleOngoing
                      ?   <h5>Next Report Available: {myEntity && myEntity.settings ? bbFormattedDateString(myEntity.settings.ongoing_cycle_complete_datetime, "shortFullMonth") : ""}</h5>

                      : <h5>Next Assessment Start: {myEntity && myEntity.settings ? bbFormattedDateString(myEntity.settings.next_cycle_datetime, "shortFullMonth") : ""}</h5>
                  }
                  <CycleProgressStepper/>
                  <br/>
                  {/*{portfolioView === false && (isAdminStaff || hasPremiumSubscription)*/}
                  {/*    ? <div className={"row"}>*/}
                  {/*    <div className={"col-12 align-self-center text-center"}>*/}
                  {/*            /!*<EarlyAccessWrapper>*!/*/}
                  {/*                <ReportHistoryDialog/>*/}
                  {/*            /!*</EarlyAccessWrapper>*!/*/}
                  {/*    </div>*/}
                  {/*</div>*/}
                  {/*: null}*/}

              </div>
          </div>
          <hr/>
          <BreachRiskScoreCyclePendingModal entity={myEntity} isBRPView={portfolioView}>

              <div className={"row "} id={"exampleAnchorEl"}>
                  <div className={"col-12"}>
                      <VectorRiskScoreLineChart portfolioView={portfolioView}
                                                entity={entityInView}
                                                cycleId={cycleInView}
                                                cycleChangeFunction={chartCallBackToChangeCycleToView}/>
                  </div>
              </div>
              {portfolioView === false
              && (isAdminStaff || hasPremiumSubscription)
              && sortedHistory
              && sortedHistory.length > 1
                  ? <span title={"View past reports to track your progress and see how your threats have changed over time."}>
                      <div className={"row mb-1 pb-1 align-self-center"}>
                      <div className={"col-6 text-center align-self-center"}>
                          <h1>Viewing Report For:  {myEntity
                          && cycleInView
                          && myEntity
                          && myEntity.cycles
                          && myEntity.cycles[cycleInView]
                          && myEntity.cycles[cycleInView].summary
                              ? bbFormattedDateString(myEntity.cycles[cycleInView].summary.cycle_datetime, "shortFullMonth")
                              : <Skeleton/>}</h1>
                      </div>

                      <div style={{marginTop: "-12px",}} className={"col-6 p-0 align-self-center"}>
                          {sortedHistory && sortedHistory.length > 1 ?
                              <Select

                                  placeholder={"Select a report date to view..."}
                                  options={sortedHistory.map((cycle)=>{
                                      return {
                                          label: bbFormattedDateString(cycle.cycle_date, "shortFullMonth"),
                                          value: cycle.cycle,
                                      }}
                                  )}
                                  onChange={(value)=> handleOnClick(value.value)}/>

                              : <em>No Past Reports Available</em>}
                      </div>
                  </div>
                  <br/>
                  </span>
                  :null
              }

              {cycleInView
                  && hasPremiumSubscription
                  && !portfolioView
                  && isPastReport
                  && myEntity
                  && myEntity.cycles
                  && myEntity.cycles[cycleInView]
                  && myEntity.cycles[cycleInView].summary &&
                  <div className={"row text-center"}>
                      <div className={"col-2"}/>
                      <h2 className={"col-8 text-center"}>
                          This report reflects the BreachRisk Score and BreachRisk Report for {myEntity.name} as of {bbFormattedDateString(myEntity.cycles[cycleInView].summary.cycle_datetime, "shortFullMonth")}.
                      </h2>
                      <div className={"col-2"}/>
                  </div>}

              {cycleInView
                  && (hasPremiumSubscription || isAdminStaff)
                  && !portfolioView
                  && isPastReport
                  // && myEntity.cycles
                  // && myEntity.cycles[cycleInView]
                  // && myEntity.cycles[cycleInView].summary
                  &&
                  <div className="row">
                      <div className={"col-1"}/>
                      <div className="col-10 tourBRScoreDial" >

                          <Paper className="text-center m-1 px-3">
                              {
                                  !loadingCycles[cycleInView]
                                  && !loadingCyclesError[cycleInView]
                                  && myEntity
                                  && myEntity.cycles
                                  && myEntity.cycles[cycleInView]
                                  && myEntity.cycles[cycleInView].summary
                                      ? <div className={""}
                                   style={{ marginTop: 15 }}>
                                  {/*<h3>{myEntity.name}</h3>*/}

                                  <BreachRiskMeter
                                      currentValueText={`${pastBreachRiskCategory} Risk`}
                                      width = {300}
                                      height = {200}
                                      value={pastBreachRiskScore}
                                      valueTextFontSize={"26px"}
                                      hideNeedle={false}
                                  />
                                  <h4>
                                      <em>
                                          {cycleInView
                                          && myEntity
                                          && myEntity.cycles
                                          && myEntity.cycles[cycleInView]
                                          && myEntity.cycles[cycleInView].summary
                                              ? bbFormattedDateString(myEntity.cycles[cycleInView].summary.cycle_datetime, "shortFullMonth")
                                              : "--"}
                                      </em>
                                  </h4>
                                  <h2>Score: <strong>{pastBreachRiskScore}</strong><small> /10</small></h2>
                              </div>
                              : <CircularProgress size={72}/>}
                          </Paper>
                      </div>
                      <div className={"col-1"}/>
                      <br/>
                  </div>
              }

              <div id={"tourStepIdentifyYourThreats"} className="row tourIdentifyThreatsRow">

                  <div className="col-sm-6 col-12 tourSummaryScatterChartCol">
                      <VectorRisk2DScatterPlot entity={entityInView}
                                               cycleInView={cycleInView}
                                                portfolioView={portfolioView}
                                                showFullScreenButton={!isPastReport}/>
                  </div>
                  <div className="col-sm-6 col-12 tourThreatsSummaryCol" id={"threatsSummaryTable"}>

                      <BRThreatsSummaryTable entity={entityInView}
                                             cycleInView={cycleInView}
                                             portfolioView={portfolioView}
                                             />
                  </div>
              </div>

              <div className="row">

                  <div className="col-12">
                      <BRReportFindingsSummary entity={entityInView}
                                               cycleInView={cycleInView}
                                               portfolioView={portfolioView}
                                                    />
                  </div>
              </div>
          </BreachRiskScoreCyclePendingModal>
          </div>

            </div>

        // </MultiBoardWrapper>
    )
}
export default Dashboard;